import React, { Component } from "react"


class pdfGeneration extends Component {
  
    componentDidMount() {
    }

}

export default pdfGeneration


// WEBPACK FOOTER //
// ./src/theme/lindt/components/pdfGen/pdfGeneration.js